export enum ButtonActionsType {
  Click = "click",
  Close = "close",
  Input = "input",
  Tab = "tab",
  Back = "back",
  Filter = "filter",
}
